exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renameInput[data-v-f49bde6a]{margin-top:8px;width:100%}.buttons[data-v-f49bde6a]{margin-top:16px;text-align:right}", ""]);

// exports
